import { memo } from 'react';
import { createPortal } from 'react-dom';
import canUseDOM from '../../common/canUseDom';
import useMetering from '../../common/hooks/useMetering';

/**
 * React component that mounts a React Portal as a child in the specified DOM element.
 * We use the useMetering Hook to determine the state of the user's meter and
 * load the aappropriate Modal inside the portal.
 */

const MeteringContainer = ({ target = 'modal-root' }) => {
  const { showSurfCheckCounter, modalToRender } = useMetering();
  if (!canUseDOM) return null;
  const modalRoot = document.getElementById(target);
  return showSurfCheckCounter ? createPortal(modalToRender, modalRoot) : null;
};

export default memo(MeteringContainer);
